export default "__VITE_PUBLIC_ASSET__55f201ea__"